module.exports = __webpack_public_path__ + "static/media/users1.e18d3086.svg";